import React, { useState } from "react";
import "../App.css";

// Import all images dynamically
const importAll = (r) => {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};

// Import images from assets folder
const images = importAll(require.context("../assets", false, /\.(jpg|png)$/));

// Reusable ReadMore Component
const ReadMore = ({ children, maxHeight = 200 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => setIsExpanded(!isExpanded);

  return (
    <div className="read-more-container">
      <div
        style={{
          maxHeight: isExpanded ? "none" : `${maxHeight}px`,
          overflow: "hidden",
          position: "relative",
          transition: "max-height 0.5s ease",
          opacity: 1,
          visibility: "visible"
        }}
      >
        {children}
        {!isExpanded && (
          <div 
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "50px",
              background: "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))"
            }}
          />
        )}
      </div>
      <button
        onClick={toggleReadMore}
        style={{
          border: "none",
          background: "none",
          color: "#007bff",
          cursor: "pointer",
          marginTop: "10px",
          fontWeight: "bold",
          display: "block"
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
};


const Services = () => {
  const services = [
    {
      id: "motor-rewinding",
      title: "Motor Rewinding Services",
      content:(
        <div>
          <p>
          Electric motors are an integral part of various industries, and with cost of replacement quite high the rewinding services helps in cutting the cost to half.  AC/ DC motor is an essential component of machines from household items to industrial-level heavy equipment, right from water pumps, generators, chiller compressors, and refrigerators to conveyor belts and pumps in machine plants. At TAAS, we serve many sectors, including marine, oil & gas, supermarkets, cement companies and power generation, that use all kinds of electromechanical equipment.
          </p>
          <p>The cost of replacing the electric motor can be quite high. However, the DC & AC motor rewinding service can cut the cost in half. Our exceptional motor rewind service will have your machine up and running in no time and at the lowest possible cost.
            <br></br>We use following steps for Motor winding:
          </p>
          <ol>
          <li><strong style={{ color: "#ff8c00" }}>Diagnostics & Overhaul:</strong> It is important to check the equipment to identify the issue thoroughly. Our specialists will conduct a comprehensive overhaul before starting with the electric motor rewinding steps.</li>
        <li><strong style={{ color: "#ff8c00" }}>Disassemble:</strong> After gathering vital data on the condition of the windings, the damaged motor windings are detached from the inside core of the machine in our machine shop.</li>
        <li><strong style={{ color: "#ff8c00" }}>Making of New Coil:</strong> What follows the removal of coils is the making of new wire coils. The key attributes of the process include layering, wire tension, and keeping track of the number of turns on the coil.</li>
        <li><strong style={{ color: "#ff8c00" }}>Fabrication:</strong> Once the coils are done, they are fabricated back into the stator slots and then connected.</li>
        <li><strong style={{ color: "#ff8c00" }}>Testing:</strong> A few tests are implemented, such as a static, polarity index test and resistance test, to guarantee the quality and mechanical integrity of the coils after the maintenance work. And lastly, the coils are insulated using High quality varnish. In case the coils need baking, we have an oven with the temperature range.</li>
      </ol>
        </div>
      ),
      image: "motor-rewinding.jpg",
    },
    {
      id: "water-pump",
      title: "Water Pump Repair",
      content: (
        <div>
          <p> 
          Whether your water pump is underperforming or is not working at all, TAAS provides top-notch industrial pump repair and pump overhaul services. From vertical turbine and submersible pump repairs to centrifugal and positive displacement pumps, our experts have years of expertise with all kinds of pumps. We provide effective, reliable, and affordable pump repair services to any of the following pumps: 
          </p>
          <ol>
            <li>Our expertise covers submersible pump repairs commonly used in wastewater treatment plants, sewage systems, and irrigation systems.</li>
            <li>We also provide pump repair services for centrifugal pumps widely used in industrial, commercial, and agricultural applications.</li>
            <li>Reciprocating pumps, commonly used in the oil and gas industry, also fall within our expertise.</li>
            <li>We also offer repair solutions for rotary pumps that serve diverse sectors like food processing, pharmaceuticals, and chemicals. These include but are not limited to gear pumps, lobe pumps, and screw pumps</li>
            <li>To extend the life of your pump, we also provide a comprehensive pump overhaul service.</li>
          </ol>
        </div>
      ),
      image: "water-pump.jpg",
    },
    {
      id: "compressor",
      title: "Compressor Repair and Service",
      content: ( 
        <div>
      <p>
      We focus on compressor services and provides all-inclusive solutions for multiple compressors, including rotary, reciprocating, centrifugal, and axial compressors. These services include fabrication, replacement, maintenance, repair, and overhaul. Whether you require screw compressor rewinding service or chiller compressor motor rewinding and repairing, we do it all.
      </p>
      <p> What differentiates us from the rest is that we provide back-up facilities for major models of Bitzer & Copeland, ensuring a peace of mind for business owners.
      </p>
      </div>
      ),
      image: "compressor.jpg",
    },
    {
      id: "mechanical-seals",
      title: "Mechanical Seals",
      content:( 
        <div>
      <p>
      Mechanical seals are vital components in mechanical systems. These seals, often positioned in differential assemblies, create a barrier to prevent lubricating oil leaks around the pinion shaft. The robust design ensures optimal performance and longevity, enhancing the overall efficiency of mechanical systems. We make sure all the products available to us are of superior quality and as per the regulations. Our commitment to quality and constant endeavour to introduce novel products and mechanical seals make us one of the best Mechanical seal suppliers in Dubai and all over the UAE.
      </p>
      <p> Over the years, we have served an array of industries including Oil, Gas, Mining, and Civil and commercial operations with our quality products. 
      </p>
      </div>
      ),
      image: "mechanical-seals.jpg",
    },
    {
      id: "generator-repair",
      title: "Generator Repair",
      content:
      ( 
        <div>
      <p>
      We provide high-quality and reliable generator stator rewinding services to our clients. Our experienced technicians are equipped with the knowledge and expertise to handle a wide range of AC and DC generator repair needs, including fault-finding, refurbishment, repairs, and specialist services such as vibration analysis.
      </p>
      <p> 
        We take pride in our ability to handle all aspects of generator repair and rewind, from dismantling and assembling to mechanical fitting, fabrication, machining, testing, balancing, painting, and storage. Some of our AC & DC generator repair capabilities includes complete rewinding, AC stator repair, and on-site preventive and predictive services.
      </p>
      <p>
        Our proficient team can conduct on-site installation, commissioning, and repair services for generators, ensuring reduced downtime and improved productivity. We possess expertise in synchronous motors and generators, encompassing both brush and brushless alternatives.
      </p>
      </div>
      ),
      image: "generator-repair.jpg",
    },
    {
      id: "heresite-coating",
      title: "Heresite Coating",
      content:
      ( 
        <div>
      <p>
      Scientific data shows that 40% of all industrial HVAC systems failures are directly, or indirectly linked to corrosion.
      </p>
      <p> 
      Heresite coatings ensure a large economic gain when applied to coils, radiators, or other process equipment as they are proven to triple the shelf-life of the equipment. As a result, corrosion prevention contributes to the air quality improvement and optimized energy efficiency of the equipment.
      </p>
      <p>
      On the other hand, due to the thin-filmed Heresite coatings applied, the impact on thermal loss efficiency is almost negligible, allowing the designers to have no hiccups on sizing or other design element selections deemed necessary.
      </p>
      <p>
      In the past decades, industrial HVAC systems or other commercial, industrial equipment are facing difficulties in handling the deterioration of equipment performance and short shelf-life especially when they were placed in a severe corrosive, extreme pH and high salt content’s environment. 
</p>
<p>The introduction of Heresite protective coatings application on HVAC heating ventilation (heating, cooling, refrigeration or other industrial process coils and components) further improvise the coil unit performance including heat transfer reduction as well as optimization of fan power requirements.

        </p>
        <p>
        Air Dry Coatings: 
        Air-Dry Coatings apply a thin, flexible film on the HVAC heating ventilation coil and is designed to prolong the shelf life of HVAC-R and other heat transfer equipment. 
        Due to the unique characteristics of the film coated, it is said to be ideal for heat transfer as well as protection of coil against humidity, saltwater and over 600 chemicals.
        We at TAAS group offer, Air Dry mode of coating both on site and at our workshop. 
        <br></br>
        Please feel free to contact us in case of any bulk requirement for Heresite(VR -514) or HereShield(WB-506)
        </p>
      </div>
      ),
      image: "heresite-coating.jpg",
    },
    {
      id: "lathe-works",
      title: "Lathe Works",
      content: ( 
        <div>
      <p>
      Known as the "mother of machining tools," lathes can be used for a variety of purposes. These include shaping, drilling, sanding, knurling, turning, cutting, and deformation. This kind of versatility in a tool is hard to beat, and that's why so many metal- and woodworkers depend on lathes for the basis of their work.
      </p>
      <p> 
      If you need a precision cutting and shaping tool, a lathe might be perfect for your project. Lathes are good for teams that need a versatile piece of equipment capable of doing the work of multiple tools.
      </p>
      <p>
      Motors can suffer many other damages that may include the destruction of the bearing, the grazing of the rotor on the stator, or the jamming of the shaft. 
      </p>
      <p>
      With high quality lathe machines and skilled workmanship, we provide one stop solution for Lathe works at TAAS.
      </p>
      </div>
      ),
      image: "lathe-works.jpg",
    },
  ];

  return (
    <div className="services-container">
      <h1 className="services-heading">Our Services</h1>
      {services.map(({ id, title, content, image }) => (
        <div className="service-section" id={id} key={id}>
          <div className="service-text">
            <h2>{title}</h2>
            <ReadMore>{content}</ReadMore>
          </div>
          <div className="service-image">
            <img
              src={images[image]}
              alt={title}
              className="image-placeholder"
              loading="lazy"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services;
